import useAppForm from "~/hooks/useAppForm"

import { PriceTableDefaultValues, PriceTableSettingsSchema, PriceTableSettingsType } from "./validation.table"
import { useState } from "react"
import { useCampingStyles } from "~/api2/hooks/useCampingStyles"
import useSites from "~/api2/hooks/useSites"
import useSearchParams from "~/hooks/useSearchParams"
import { useNotification } from "~/contexts/NotificationProvider"

export default function usePricingTableForm() {
  const { showNotification } = useNotification()
  const searchParams = useSearchParams()
  const selectedTab = searchParams.get("s")

  const {
    index: {
      data: campingStyles,
      refetch: refetchCampingStyles,
      isLoading: isLoadingCampingStyles,
      isFetching: isFetchingCampingStyles,
    },
  } = useCampingStyles()

  const {
    index: { data: sites, refetch: refetchSites, isLoading: isLoadingSites, isFetching: isFetchingSites },
  } = useSites()

  console.log(selectedTab, campingStyles, sites)

  const campingStyle = campingStyles?.find((style) => style?.id === selectedTab.split("_")[1])
  const [defaultValues, setDefaultValues] = useState<PriceTableSettingsType>(PriceTableDefaultValues)
  const reactHookForm = useAppForm<PriceTableSettingsType>({
    defaultValues,
    schema: PriceTableSettingsSchema,
  })

  return {
    reactHookForm,
    campingStyle,
    sites,
    showNotification,
  }
}
